import React from 'react';
import { Helmet } from 'react-helmet';

interface FAQItem {
  question: string;
  answer: string;
}

interface StructuredDataFAQProps {
  faqItems: FAQItem[];
  pageName?: string;
}

/**
 * Component for adding FAQ structured data (Schema.org) for AEO optimization
 */
const StructuredDataFAQ: React.FC<StructuredDataFAQProps> = ({ faqItems, pageName }) => {
  if (!faqItems || faqItems.length === 0) return null;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredDataFAQ;